<script>
  import { HOME } from '../../data/sections.js'
  import {
    y,
    showLabelPage,
    posBeforeLabel,
    posBeforeBuy,
  } from '../../stores.js'
  import { showModal } from '../../stores.js'

  function getCoords(elem) {
    let e = document.getElementById(elem)
    let box = e.getBoundingClientRect()
    return box.top + window.pageYOffset - 60
  }

  function scrollTo(section) {
    window.scrollTo(0, getCoords(section))
  }
</script>

<footer class="content-wrapper">
  <div class="footer-wrapper">
    <div class="logo">
      <a href="https://typofonderie.com/"><img
          src="./images/Logo.svg"
          alt="Typofonderie Logo" /></a>
    </div>
    <section class="narrow">
      <ul>
        {#each HOME.content.item_list as item}
          <li on:click={() => scrollTo(item.name)}><a>{item.title}</a></li>
        {/each}
        <li
          on:click={() => {
            showLabelPage.set(true)
            posBeforeLabel.set($y)
          }}>
          <a>Italian shops & hotels</a>
        </li>
        <li
          on:click={() => {
            showModal.set(!$showModal)
            document.body.style.position = 'fixed'
            document.body.style.overflowY = 'hidden'
            posBeforeBuy.set($y)
          }}>
          <a>Buy & Download</a>
        </li>
      </ul>
    </section>
    <section class="links" style="
    padding-top: 3px;
    ">
      <p>
        <a href="https://typofonderie.com/fonts/arteria-compress-family/">Buy
          Arteria</a>
      </p>
      <p>
        Arteria typeface and concept by
        <a href="https://typofonderie.com/designer/jean-francois-porchez/">Jean
          François Porchez</a>
      </p>
      <p>
        Minisite coded by
        <a href="https://typofonderie.com/about/foundry-team/#joachimvu">Joachim
          Vu</a>,
        <a href="http://zecraft.com">ZeCraft</a>
      </p>
      <p>
        Set in
        <a
          href="https://typofonderie.com/fonts/arteria-compress-family/">Arteria
        </a>and
        <a href="https://typofonderie.com/fonts/mencken-family/">Mencken</a>
      </p>
    </section>
  </div>
</footer>

<style lang="scss">
  @import '../../responsive.scss';
  footer {
    background-color: var(--typofonderie-grey);
    padding: 3em;
    font-family: 'mencken-std-text';
    font-weight: 400;
    .footer-wrapper {
      display: grid;
      grid-template-columns: 4fr minmax(200px, 1fr) minmax(300px, 3fr);
      .logo {
        max-width: 400px;
        margin-right: 100px;
      }
      .logo::after {
        display: block;
        content: '';
        background-image: url('../images/Logo-baseline.svg');
        position: relative;
        width: 288px;
        height: 16px;
        background-size: contain;
        left: 57px;
        top: 5px;
      }
      section {
        color: #c2c2c2;
        padding-right: 40px;
        ul {
          list-style: none;
          margin: 0;
          padding: 0;
          li {
            text-transform: uppercase;
            letter-spacing: 0.1em;
            cursor: pointer;
            font-size: 2rem;
            font-family: 'Arteria-Regular';
            line-height: 1em;
            transition: color 0.2s;
            margin-bottom: 5px;
            a {
              color: var(--light);
              &:hover {
                color: var(--red);
              }
            }
          }
        }
        p {
          font-weight: 400;
          margin: 0;
          line-height: 1.7em;
          font-size: 1.2rem;
          a {
            color: white;
            text-decoration: none;
            transition: color 0.2s;
            &:hover {
              opacity: 0.5;
            }
          }
          &.top {
            cursor: pointer;
            margin-bottom: 0;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            cursor: pointer;
            font-size: 1rem;
            line-height: 1.7em;
            font-weight: 700;
            transition: color 0.2s;
            &:hover {
              color: white;
            }
          }
        }
      }
      .narrow {
        max-width: 200px;
      }
    }

    @include for-tablet {
      .footer-wrapper {
        grid-template-columns: 1fr 1fr;
        .logo {
          margin-bottom: 40px;
          max-width: 300px;
          grid-column: 1 / span 2;
        }
        section {
          grid-row: 2;
        }
        .narrow {
          margin-left: 58px;
        }
      }
    }

    @include for-phone {
      padding: 2em 1em;
      .footer-wrapper {
        .narrow {
          grid-column: 1 / span 2;
          margin-left: 0;
          margin-bottom: 10px;
        }
        .links {
          grid-row: 3;
          grid-column: 1 / span 2;
        }
      }
    }
  }
</style>
